import { useContext } from 'react';
import { AuthContext, type AuthContextType } from '@/features/auth/auth';

/**
 * Returns application-level auth actions (login, logout, getAccessToken) and error state.
 *
 * For authentication *state*, use msal-react hooks directly:
 *   - useIsAuthenticated() — boolean
 *   - useMsal().inProgress — InteractionStatus (use to gate loading spinners)
 *   - useAccount()         — AccountInfo | null (currently active account)
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
